import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Divider, ListItem, ListItemIcon, ListItemText, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import List from '@mui/material/List'
import BackpackIcon from '@mui/icons-material/Backpack'
import { useAuth } from '../../../../../../context/Auth'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dividerFullWidth: {
      margin: `5px 0 0 ${theme.spacing(2)}`,
    },
  })
)

export const GameDrawerList = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const classes = useStyles()

  if (auth && auth.id) {
    return (
      <List>
        <Divider component="li" />
        <li>
          <Typography
            className={classes.dividerFullWidth}
            color="textSecondary"
            display="block"
            variant="caption"
          >
            Baza gry
          </Typography>
        </li>

        <ListItem button onClick={() => navigate('/items')}>
          <ListItemIcon>
            <BackpackIcon />
          </ListItemIcon>
          <ListItemText primary={'Przedmioty'} />
        </ListItem>
        <ListItem button onClick={() => navigate('/spells')}>
          <ListItemIcon>
            <AutoFixHighIcon />
          </ListItemIcon>
          <ListItemText primary={'Czary'} />
        </ListItem>
      </List>
    )
  }

  return <></>
}
